/* Japan Card Collect — page collection (série / rareté) : filtres sur grille Liquid.
   Les cartes sont rendues côté serveur ; le JS filtre/trie les nœuds DOM (parité set.js). */
(function () {
  "use strict";
  const I18N = window.I18N || { fr: {}, en: {} };
  const $ = (id) => document.getElementById(id);
  const grid = $("cardGrid");
  if (!grid) return;
  const lang = () => ((document.documentElement.lang || "fr") === "en" ? "en" : "fr");
  const t = (k) => (I18N[lang()] && I18N[lang()][k]) || (I18N.fr && I18N.fr[k]) || "";
/* Devise : NE PAS coder « € » en dur. Avec Shopify Markets et les devises locales, les prix
   Liquid arrivent déjà CONVERTIS dans la devise du visiteur : un client polonais recevait 859
   (zloty) affichés « 859,00 € », soit 4,4x le vrai prix de la carte. On formate donc avec la
   devise active, en gardant les conventions typographiques de la langue. */
  const DEVISE = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  const fmtMoney = (n) => { try { return new Intl.NumberFormat(lang() === "en" ? "en-GB" : "fr-FR",
      { style: "currency", currency: DEVISE }).format(n); }
    catch (e) { return (lang() === "en" ? "" : "") + n.toFixed(2) + " " + DEVISE; } };
  const money = (p) => fmtMoney((+p));
  const RAR_ORDER = ["STAR", "UR", "MUR", "HR", "SEC", "SAR", "CRY", "SHINY", "LGD", "LVX",
    "SSR", "SR", "ex", "CHR", "CSR", "PRIME", "A", "K", "S", "AR", "RR", "RRR", "H", "R", "ACE", "PR"];

  /* collecte ré-exécutable : « Charger plus » ajoute des cartes à la grille en cours de route */
  let cards = [];
  function collectCards() {
    cards = Array.from(grid.querySelectorAll(".ccard")).map((el, i) => ({
      el,
      idx: i,                                 /* ordre d'origine (= ordre de la collection) */
      n: parseInt(el.dataset.n, 10) || 0,
      rar: el.dataset.rar || "",
      price: parseFloat(el.dataset.price) || 0,
      stock: parseInt(el.dataset.stock, 10) || 0,
      fr: el.dataset.fr || "",
      en: el.dataset.en || "",
    }));
  }
  collectCards();
  if (!cards.length) return;

  /* tri par défaut : « manual » (ordre de la collection, ex. nouveautés = ordre Vinted) via data-default-sort */
  const state = { rarity: "all", avail: "all", sort: grid.dataset.defaultSort || "stock", priceMin: 0, priceMax: Infinity };
  let maxP = Math.ceil(Math.max(1, ...cards.map((c) => c.price)));

  /* ---- lignes de stock + noms par langue ---- */
  function renderTexts() {
    const L = lang();
    cards.forEach((c) => {
      const nameEl = c.el.querySelector(".ccard__name-txt");
      if (nameEl) nameEl.textContent = (L === "en" ? c.en : c.fr) || c.fr;
      const line = c.el.querySelector("[data-stockline]");
      if (!line) return;
      if (c.stock === 0) {
        line.className = "ccard__stock ccard__stock--out";
        line.textContent = t("set_stock_out");
      } else {
        const tier = c.stock >= 5 ? "in" : c.stock >= 3 ? "mid" : "low";
        line.className = "ccard__stock ccard__stock--" + tier;
        line.textContent = t("set_stock_in") + " · " + c.stock + " " +
          (c.stock === 1 ? t("pp_stock_left_one") : t("set_stock_left"));
      }
    });
  }

  /* ---- chips rareté dynamiques ---- */
  function buildRarityChips() {
    const box = $("rarityFilters");
    if (!box) return;
    const present = [...new Set(cards.map((c) => c.rar).filter(Boolean))].sort((a, b) => {
      const ia = RAR_ORDER.indexOf(a), ib = RAR_ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    box.innerHTML =
      '<button class="chip' + (state.rarity === "all" ? " is-active" : "") + '" data-rarity="all">' + t("set_f_premium") + "</button>" +
      present.map((r) => '<button class="chip' + (state.rarity === r ? " is-active" : "") + '" data-rarity="' + r + '">' + r + "</button>").join("");
    bindChips("rarityFilters", "rarity");
  }

  function render() {
    let list = cards.filter((c) =>
      (state.rarity === "all" || c.rar === state.rarity) &&
      (state.avail === "all" || (state.avail === "in" ? c.stock > 0 : c.stock === 0)) &&
      (c.price >= state.priceMin && c.price <= state.priceMax));
    const shown = new Set(list);
    cards.forEach((c) => { c.el.hidden = !shown.has(c); });
    /* compteur en tête de page : reflète le nombre de cartes filtrées (ex. « En stock » → 7) */
    const cnt = $("setCount");
    if (cnt) cnt.textContent = list.length;
    let order = list.slice();
    if (state.sort === "asc") order.sort((a, b) => a.price - b.price);
    else if (state.sort === "desc") order.sort((a, b) => b.price - a.price);
    else if (state.sort === "num") order.sort((a, b) => a.n - b.n);
    else if (state.sort === "manual") order.sort((a, b) => a.idx - b.idx);
    else order.sort((a, b) => (b.stock > 0) - (a.stock > 0) || a.n - b.n);
    order.forEach((c) => grid.appendChild(c.el));
    let emptyEl = grid.querySelector(".set-empty--dyn");
    if (!list.length) {
      if (!emptyEl) {
        emptyEl = document.createElement("p");
        emptyEl.className = "set-empty set-empty--dyn";
        emptyEl.style.cssText = "grid-column:1/-1;display:block";
        emptyEl.textContent = "—";
        grid.appendChild(emptyEl);
      }
    } else if (emptyEl) emptyEl.remove();
  }

  /* ---- contrôles ---- */
  function bindChips(boxId, key) {
    const box = $(boxId); if (!box) return;
    box.querySelectorAll("[data-" + key + "]").forEach((b) => {
      b.addEventListener("click", () => {
        box.querySelectorAll("[data-" + key + "]").forEach((x) => x.classList.remove("is-active"));
        b.classList.add("is-active");
        state[key] = b.getAttribute("data-" + key);
        render();
      });
    });
  }
  bindChips("availFilters", "avail");
  const sortSel = $("sortSel");
  if (sortSel) sortSel.addEventListener("change", (e) => { state.sort = e.target.value; render(); });

  function syncPrice(labelOnly) {
    const mn = $("priceMin"), mx = $("priceMax");
    if (!mn || !mx) return;
    let a = parseFloat(mn.value), b = parseFloat(mx.value);
    if (a > b) { const tmp = a; a = b; b = tmp; }
    state.priceMin = a; state.priceMax = b;
    $("priceVal").textContent = money(a) + " – " + money(b);
    const span = maxP || 1;
    $("rangeFill").style.left = (a / span * 100) + "%";
    $("rangeFill").style.width = ((b - a) / span * 100) + "%";
    if (!labelOnly) render();
  }
  const mn = $("priceMin"), mx = $("priceMax");
  if (mn && mx) {
    mn.max = String(maxP); mn.value = "0";
    mx.max = String(maxP); mx.value = String(maxP);
    mn.addEventListener("input", () => { if (+mn.value > +mx.value) mx.value = mn.value; syncPrice(); });
    mx.addEventListener("input", () => { if (+mx.value < +mn.value) mn.value = mx.value; syncPrice(); });
    syncPrice(true);
  }

  /* ---- pré-sélection rareté via URL (?rar=SAR) + deep-link carte (?card=n) ---- */
  const params = new URLSearchParams(location.search);
  const wantRar = (params.get("rar") || "").toUpperCase();
  if (wantRar && cards.some((c) => c.rar === wantRar)) state.rarity = wantRar;

  function highlightCard() {
    const want = params.get("card");
    if (!want) return;
    const el = grid.querySelector('.ccard[data-n="' + want + '"]');
    if (!el) return;
    setTimeout(() => {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("ccard--flash");
      setTimeout(() => el.classList.remove("ccard--flash"), 2200);
    }, 250);
  }

  /* ---- clic carte → fiche produit (l'ajout panier est géré par jcc-cart.js) ---- */
  grid.addEventListener("click", (e) => {
    if (e.target.closest(".ccard__add")) return;
    const art = e.target.closest(".ccard");
    if (art && art.dataset.href) location.href = art.dataset.href;
  });

  const cta = $("setCtaBtn");
  if (cta) cta.addEventListener("click", () => { location.href = "/#newsletter"; });

  /* ---- « Charger plus de cartes » : fetch de la page paginée suivante, cartes ajoutées à la
     grille, collecte + filtres + tri ré-appliqués (l'ordre collection est préservé en fin de grille) ---- */
  const lm = $("loadMore");
  if (lm) lm.addEventListener("click", () => {
    const next = parseInt(lm.dataset.page, 10) || 2;
    const pages = parseInt(lm.dataset.pages, 10) || 1;
    lm.disabled = true;
    const oldTxt = lm.textContent;
    lm.textContent = "…";
    const u = new URL(location.href);
    u.searchParams.set("page", String(next));
    fetch(u.toString()).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      doc.querySelectorAll("#cardGrid .ccard").forEach((n) => grid.appendChild(document.importNode(n, true)));
      lm.dataset.page = String(next + 1);
      collectCards();
      /* borne prix : étend le slider si la nouvelle page dépasse l'ancien max */
      const newMax = Math.ceil(Math.max(1, ...cards.map((c) => c.price)));
      const mn2 = $("priceMin"), mx2 = $("priceMax");
      if (newMax > maxP) {
        const wasFull = mx2 && +mx2.value >= +mx2.max;
        maxP = newMax;
        if (mn2) mn2.max = String(maxP);
        if (mx2) { mx2.max = String(maxP); if (wasFull) mx2.value = String(maxP); }
        syncPrice(true);
      }
      renderTexts();
      buildRarityChips();
      render();
      if (next + 1 > pages) { const box = lm.closest(".set-loadmore"); if (box) box.remove(); }
      else { lm.disabled = false; lm.textContent = oldTxt; }
    }).catch(() => { lm.disabled = false; lm.textContent = oldTxt; });
  });

  renderTexts();
  buildRarityChips();
  render();
  highlightCard();

  new MutationObserver(() => { renderTexts(); buildRarityChips(); syncPrice(true); render(); })
    .observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });
})();
